<template>
  <div class="c-tabbed-index" :class="{'-active': state}">
    <div class="__slot" v-show="false">
      <slot></slot>
    </div>
    <div class="c-tabbed-index__header">
      <ul class="c-tabbed-index__tablist">
        <li class="c-tabbed-index__tab" 
          v-for="(tab, index) in tabs"
          :key="index" 
          @click="show(tab.name)"
          :class="{'-active': selected === tab.name}"
        >
          {{tab.label}}
        </li>
      </ul>
    </div>

    <div class="c-square-index -active">
      <div class="c-square-index__inner">
        <ul class="c-square-index__list">
          <li class="c-square-index__item" 
            v-for="(item, index) in list" 
            :key="index"
            v-if="item.category === selected || selected === 'all'"
          >
            <a :href="item.href" v-background="item.thumb">
              <span class="c-square-index__caption">
                {{item.caption}}
              </span>
            </a>
            <p class="c-square-index__description">
              <span class="c-square-index__date" v-if="item.date">{{item.date | date}}</span>
              {{item.description}}
            </p>
          </li>
        </ul>
      </div>
    </div>
    <!-- /.c-square-index -->
  </div>
</template>

<script>

import u from "../lib/u.js";
import categories from "../data/topics-categories.js";

export default {

  props: ["modifier"],

  data (){
    return {
      state: false,
      tabs: [],
      list: [],
      selected: "all",
    }
  },

  filters: {
    date (value){
      return moment(value).format("YYYY年M月D日");
    }
  },

  directives: {
    background (el, o){
      el.style.backgroundImage = `url(${o.value})`;
    }
  },

  mounted (){
    this.tabs = categories;

    $.ajax({
      url: "./index.json"
    })
    .then((data) => {
      this.list = data.topics.map((item) => {
        item.caption = this.getCategory(item.category).label;
        return item;
      })
    });

    // hashから復帰
    this.initByHash();

    this.state = true;
  },

  methods: {

    getCategory (name){
      let r = categories.filter((item) => {
        return item.name === name;
      });
      return r.length ? r[0] : {label: null};
    },

    show (name){
      this.selected = name;
    },

    initByHash (){
      let whitelist = categories.map((item) => {
        return item.name;
      });
      let hash = location.hash.replace(/^#/, "");
      if(whitelist.indexOf(hash) >= 0){
        this.selected = hash;
      }
    }
  }
  
}
</script>



// WEBPACK FOOTER //
// src/component/tabbed-index.vue